module.exports = __webpack_public_path__ + "images/if6_yes.svg?eb99f2c661667ebc00d07cb638d4055e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/if6_yes.svg
// module id = D5jm
// module chunks = 0